(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('InitiativeUpdateStatusReviewDeliverablesByInitiativeController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'assessmentByInitiative', 'fiscalYearQuarterKeys'];

    function Controller($scope, $state, $stateParams, assessmentByInitiative, fiscalYearQuarterKeys) {

        if ($state.is('initiativeUpdateStatusReview.initiatives.review.byInitiative.deliverables')) {

            if (fiscalYearQuarterKeys.length === 0) {

                $state.go('initiativeUpdateStatusReview.initiatives.review.byInitiative.noDeliverables', {},
                    { location: 'replace' }
                );

                return;
            }

            $state.go('initiativeUpdateStatusReview.initiatives.review.byInitiative.deliverablesByQuarter',
                {
                    PlanInitiativeID: $stateParams.PlanInitiativeID,
                    FiscalYearQuarterKey: fiscalYearQuarterKeys[0],
                },
                { location: 'replace' }
            );

            return;
        }

        $scope.assessmentByInitiative = assessmentByInitiative;
        $scope.initiativesList = assessmentByInitiative.InitiativesList;
        $scope.planInitiative = assessmentByInitiative.PlanInitiative;

    }
})();